import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const LEAF_IMAGES = ["/leaf/leaf-1.png", "/leaf/leaf-2.png"];

function randomLeaf(id) {
  const spin = Math.random() < 0.25;
  return {
    id,
    img: LEAF_IMAGES[Math.floor(Math.random() * LEAF_IMAGES.length)],
    x: 2 + Math.random() * 92,
    size: 16 + Math.random() * 26,
    duration: 9 + Math.random() * 7,
    sway: (Math.random() - 0.5) * 130,
    sway2: (Math.random() - 0.5) * 90,
    spin: spin ? 360 + Math.random() * 360 : (Math.random() - 0.5) * 190,
    opacity: 0.45 + Math.random() * 0.35,
  };
}

function Leaf({ leaf, onDone }) {
  return (
    <motion.div
      className="absolute"
      style={{ left: `${leaf.x}vw`, top: "-8vh", zIndex: 1 }}
      initial={{ y: "-10vh", x: 0, rotate: 0, opacity: 0 }}
      animate={{
        y: "112vh",
        x: [0, leaf.sway, leaf.sway2, leaf.sway * 0.4],
        rotate: leaf.spin,
        opacity: [0, leaf.opacity, leaf.opacity, 0],
      }}
      transition={{ duration: leaf.duration, ease: "easeInOut", times: [0, 0.3, 0.7, 1] }}
      onAnimationComplete={() => onDone(leaf.id)}
      data-testid={`falling-leaf-${leaf.id}`}
    >
      <img
        src={leaf.img}
        alt=""
        aria-hidden="true"
        style={{ width: `${leaf.size}px`, filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.35))" }}
      />
    </motion.div>
  );
}

export default function LeavesLayer() {
  const [leaves, setLeaves] = useState([]);
  const idRef = useRef(0);
  const timerRef = useRef(null);
  const [reduced] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let alive = true;

    const spawn = () => {
      if (!alive) return;
      setLeaves((current) => (current.length >= 9 ? current : [...current, randomLeaf(++idRef.current)]));
      timerRef.current = setTimeout(spawn, 650 + Math.random() * 950);
    };
    timerRef.current = setTimeout(spawn, 800);

    return () => {
      alive = false;
      clearTimeout(timerRef.current);
    };
  }, []);

  if (reduced) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[20] overflow-hidden"
      data-testid="leaves-layer"
      aria-hidden="true"
    >
      {leaves.map((l) => (
        <Leaf key={l.id} leaf={l} onDone={(id) => setLeaves((cur) => cur.filter((x) => x.id !== id))} />
      ))}
    </div>
  );
}
